/**
 * /emails/* router-shell (ADR-0036).
 *
 * 2 sub-rotas: configuracao + historico.
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Configuracao from "./Configuracao";
import Historico from "./Historico";


export default function EmailsShell() {
  return (
    <Routes>
      <Route index element={<Navigate to="configuracao" replace />} />
      <Route path="configuracao" element={<Configuracao />} />
      <Route path="historico" element={<Historico />} />
      <Route path="*" element={<Navigate to="configuracao" replace />} />
    </Routes>
  );
}
